// src/components/coinflipInfoModal.js
import React from 'react';

const InfoModal = ({ children, onClose }) => {
    return (
        <div
            style={{
                position: 'fixed',
                top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 2000,
            }}
            onClick={onClose}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                style={{
                    backgroundColor: '#12162e',
                    border: '2px solid #00FFD1',
                    borderRadius: '15px',
                    padding: '30px',
                    color: '#fff',
                    width: '90%',
                    maxWidth: '500px',
                    boxShadow: '0 0 30px #00FFD1',
                    textAlign: 'center',
                }}
            >
                {children}
                <button
                    onClick={onClose}
                    style={{
                        marginTop: '20px',
                        backgroundColor: '#00FFD1',
                        color: '#12162e',
                        border: 'none',
                        padding: '10px 20px',
                        borderRadius: '10px',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                    }}
                >
                    Close
                </button>
            </div>
        </div>
    );
};

export default InfoModal;
